import { Message } from '@restate/core'
import axios from 'axios'
import { config } from 'config/config'
import { SharingTraining } from 'model/SharingTraining'
import { SharingTrainingDto } from 'model/SharingTraining.dto'
import { routes } from 'model/ctrl/routes'
import { SingleTrainingDocument } from 'model/db/SingleTrainingDocument.db-schema'
import { AppRoutes } from 'routes'
import { tools } from 'services/utils/tools'
import { AppStore } from 'state/store'
import { USERROLES } from '../../model/UserRole'

export interface SingleTrainingView extends SingleTrainingDocument {
  origin: string
}

export interface SingleTrainingShareMessage extends Message {
  type: 'Page/SingleTraining/Share'
}

export interface SingleTrainingDownloadCertificateMessage extends Message {
  type: 'Page/SingleTraining/DownloadCertificate'
  payload: { trainingId: string }
}

export const connectSingleTrainingsPage = (store: AppStore) => {
  const { onLoginPageEnter, http, snackBar, hasUserRole, onAction } = tools(
    store
  )

  onLoginPageEnter(AppRoutes.SingleTrainings).subscribe(() => {
    hasUserRole(USERROLES.Trainee).subscribe(() => {
      http({
        route: { path: routes.sharing.trainee.sharingObjects },
      }).subscribe(res => {
        store.next(state => {
          state.pages.singleTrainings.traineeSharingObjects = res as any // TODO: fix typing
        })
      })

      http<SingleTrainingView[]>({
        route: { path: routes.cps.singleTrainings },
      }).subscribe(
        res => {
          store.next(state => {
            state.pages.singleTrainings.singleTrainings = res
          })
        },
        () => {
          snackBar.error('Single Trainings could not be fetched')
        }
      )
    })
  })

  onAction({ type: 'Page/SingleTraining/Share' }).subscribe(() => {
    const { share } = store.state.pages.singleTrainings
    const sharingTrainingDto: SharingTrainingDto = {
      singleTrainingId: share.selectedTrainingId,
      sharingObjectIds: share.selectedTraineeSharingObject,
    }

    store.next(state => {
      state.pages.singleTrainings.share.selectedTrainingId = ''
      state.pages.singleTrainings.share.selectedTraineeSharingObject = []
    })

    http<SharingTraining>({
      method: 'POST',
      route: { path: routes.sharing.trainee.postSingleTraining },
      data: sharingTrainingDto,
    }).subscribe(
      _success => {
        snackBar.success('Single Training shared!')
        http({
          route: { path: routes.sharing.trainee.sharingObjects },
        }).subscribe(res => {
          store.next(state => {
            state.pages.singleTrainings.traineeSharingObjects = res as any // TODO: fix typing
          })
        })
      },
      _err => {
        snackBar.error('Single Training could not be shared')
        console.log(_err)
      }
    )
  })

  onAction({
    type: 'Page/SingleTraining/DownloadCertificate',
  }).subscribe(async pack => {
    const { trainingId } = (pack.message as SingleTrainingDownloadCertificateMessage)
      .payload

    try {
      const language = store.state.i18n.locale.split(/[-_]/)[0]
      const url =
        config().api +
        routes.cps.singleTrainingCertificate.replace(':id', trainingId) +
        `?lang=${encodeURIComponent(language)}`

      const response = await axios.get(url, { responseType: 'blob' })

      const blobUrl = URL.createObjectURL(response.data as Blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = `corpatch-certificate-${trainingId}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(blobUrl)
    } catch (_err) {
      snackBar.error('Certificate could not be downloaded')
      console.log(_err)
    }
  })
}
